import React from 'react';
import FormSteps from '../FormSteps';
import linkIcon from '../../../../../assets/svg/Icon-Link.svg';

const WebsiteStep = ({ formik, goToNextStep, skipStep }) => {
  const handleNext = () => {
    goToNextStep();
  };

  return (
    <FormSteps
      header="Drop a link to your website or portfolio (optional)"
      description="This helps others discover your work."
      nextButton={handleNext}
      skipButton={skipStep}
    >
      <div className="field">
        <div className="field-body">
          <div className="control input-icon-wrapper">
            <img
              src={linkIcon}
              alt="link"
              className="input-icon-link"
            />
            <input
              type="text"
              id="website"
              name="website"
              placeholder="http://"
              className="input has-background-white input-with-icon"
              value={formik.values.website}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>
      </div>
    </FormSteps>
  );
};

export default WebsiteStep;